// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".axisLabels[data-v-5c5e2f93]{top:-20px;margin-right:-17px;color:#5d5d5d;font-size:11px}.q-table th[data-v-5c5e2f93]{background:#000!important;color:#fff!important;font-weight:700!important}", ""]);
// Exports
module.exports = exports;
